const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

/* =====================================================================
   VIA ÓCULOS — Fade + leve subida em todos os blocos ao rolar (13/10/2026)
   Leve: 1 IntersectionObserver só, anima apenas opacity/transform (GPU),
   para de observar cada bloco depois que ele aparece.
   - Não toca no que já está na tela ao carregar (sem "piscar", sem afetar LCP)
   - Não duplica os blocos que o Dawn já anima (.scroll-trigger)
   - Ignora header, cart drawer, barra fixa, sliders horizontais e abas escondidas
   - Respeita "reduzir movimento" do celular e o editor de temas
   ===================================================================== */
(function () {
  if (window.__voFadeInit) return;
  window.__voFadeInit = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var css =
    '.vo-fade{opacity:0;transform:translate3d(0,22px,0);transition:opacity .7s cubic-bezier(.22,.61,.36,1),transform .7s cubic-bezier(.22,.61,.36,1);transition-delay:var(--vo-d,0ms)}' +
    '.vo-fade.vo-in{opacity:1;transform:none}';
  var st = document.createElement('style');
  st.id = 'vo-fade-css';
  st.textContent = css;
  document.head.appendChild(st);

  var SKIP_TAGS = { STYLE: 1, SCRIPT: 1, TEMPLATE: 1, LINK: 1, META: 1, NOSCRIPT: 1, BR: 1 };
  var SLIDER = 'slider-component, slideshow-component, .slider, .swiper, [class*="carousel"], [class*="Carousel"]';

  function realChildren(el) {
    var out = [];
    for (var i = 0; i < el.children.length; i++) {
      var c = el.children[i];
      if (!SKIP_TAGS[c.tagName] && c.offsetHeight > 0) out.push(c);
    }
    return out;
  }

  function scrollsX(el) {
    var cs = getComputedStyle(el);
    return (cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 4;
  }

  // Desce pelos wrappers de 1 filho só até achar a lista de blocos da seção
  function blocksOf(section) {
    var el = section, guard = 0, kids = realChildren(el);
    while (kids.length === 1 && guard++ < 6) { el = kids[0]; kids = realChildren(el); }
    if (kids.length < 2 || kids.length > 24) return [section];
    if (el.matches(SLIDER) || el.closest(SLIDER) || scrollsX(el)) return [section];
    return kids;
  }

  function eligible(el, vh, vw) {
    if (!el || el.offsetHeight === 0 || el.offsetParent === null && getComputedStyle(el).position !== 'fixed') return false;
    if (el.classList.contains('scroll-trigger') || el.querySelector('.scroll-trigger')) return false;
    if (el.closest('cart-drawer, .vo-sticky-bar, header, sticky-header, .shopify-section-group-header-group')) return false;
    var r = el.getBoundingClientRect();
    if (r.top < vh * 0.92) return false;          // já visível ao carregar: não anima
    if (r.left >= vw || r.right <= 0) return false; // fora da tela na horizontal
    return true;
  }

  function init() {
    var vh = window.innerHeight, vw = window.innerWidth;
    var sections = document.querySelectorAll('#MainContent > .shopify-section, .shopify-section-group-footer-group');
    var targets = [];
    sections.forEach(function (sec) {
      var list = blocksOf(sec);
      list.forEach(function (el) { if (eligible(el, vh, vw)) targets.push(el); });
    });
    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        el.style.setProperty('--vo-d', Math.min(n++, 4) * 90 + 'ms');
        el.classList.add('vo-in');
        // limpa tudo depois da animação (não deixa transform preso nos blocos)
        setTimeout(function () {
          el.classList.remove('vo-fade', 'vo-in');
          el.style.removeProperty('--vo-d');
        }, 1200);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    targets.forEach(function (el) { el.classList.add('vo-fade'); io.observe(el); });

    // segurança: se o cliente pular direto para o fim (âncora/voltar), revela o que ficou acima
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      targets.forEach(function (el) { el.classList.remove('vo-fade', 'vo-in'); });
    });
  }

  function start() {
    // roda depois do primeiro desenho da página, sem disputar com o carregamento
    if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 600 });
    else setTimeout(init, 60);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
